export const enum Direction {
  UP = "UP",
  DOWN = "DOWN",
  RIGHT = "RIGHT",
  LEFT = "LEFT",
}

export const enum GameRule {
  WITH_BORDERS = "WITH_BORDERS",
  WITHOUT_BORDERS = "WITHOUT_BORDERS",
}
